// extracted by mini-css-extract-plugin
export default {"status":"statusCard_status__zprqO","left":"statusCard_left__DQogd","right":"statusCard_right__IGGsj","name":"statusCard_name__NqTuX","logo":"statusCard_logo__2Ta9G"};